var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('page-header-logo'),_c('lang-switch')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }